import React from 'react';
import './RestaurantIcon.less';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export const RestaurantIcon = ({src}) => {
	return (
		<div className="restaurant-icon">
			<LazyLoadImage className="restaurant-icon__image" effect="opacity" src={src}/>
		</div>
	);
};
